import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/index';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'handsontable/dist/handsontable.full.min.css';
import 'antd/dist/reset.css';
import './App.css';
import packageJson from '../package.json';

const clearCookies = () => {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
  }
};

const clearAllData = () => {
  localStorage.clear();
  sessionStorage.clear();
  clearCookies();
};

const VersionCheck = ({ children }) => {
  const currentVersion = packageJson.version;

  useEffect(() => {
    const savedVersion = localStorage.getItem('appVersion');

    if (!savedVersion || savedVersion !== currentVersion) {
      clearAllData();
      localStorage.setItem('appVersion', currentVersion);
      if (!window.location.href.includes('?reload=true')) {
        window.location.href = `${window.location.href}?reload=true`; // Thêm query param để tránh vòng lặp
      } else {
        console.log('Reload complete, using new version');
      }
    }
  }, [currentVersion]);

  return <>{children}</>;
};

function App() {
  return (
    <Router>
      <VersionCheck>
        <AppRoutes />
      </VersionCheck>
    </Router>
  );
}

export default App;
